
import translations from './OutOfStockBlock.translations'

export default {
  computed: {
    translations: () => translations,
  },
}
